var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unresolved-tag"},[_vm._v(" "+_vm._s(_vm.$t('unresolved'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }